import { TZDateMini } from '@date-fns/tz';
import { useEffect } from 'react';

import type { TimeValue } from '@dynatrace-sdk/units/types/packages/util/units/src/util-format/time.js';
import { getTimezone } from '@dynatrace-sdk/user-preferences';

import { getStratoLogger } from '../../../core/sdk/sdk-logger.js';

/**
 * Hook to log invalid min/max prop values: warns when a value could not be
 * parsed as a date expression, and errors when min is larger than max.
 * @internal
 */
export const useMinMaxLogger = (
  min?: TimeValue | null,
  max?: TimeValue | null,
  componentName?: string,
) => {
  const logger = getStratoLogger(
    componentName ?? 'Date Component - MinMaxLogger',
  );

  const timezone = getTimezone();

  useEffect(() => {
    if (min && !min.absoluteDate) {
      logger.warn(
        `The 'min' prop value "${min.value}" could not be parsed as a valid date expression and will be ignored.`,
      );
    }
    if (max && !max.absoluteDate) {
      logger.warn(
        `The 'max' prop value "${max.value}" could not be parsed as a valid date expression and will be ignored.`,
      );
    }
    if (
      min &&
      max &&
      min.absoluteDate &&
      max.absoluteDate &&
      new TZDateMini(min.absoluteDate, timezone).getTime() >=
        new TZDateMini(max.absoluteDate, timezone).getTime()
    ) {
      logger.error(
        `Min prop is larger than the max prop. Min: ${min.value}, Max: ${max.value}`,
      );
    }
  }, [min, max, logger, timezone]);
};
